import { PasscodesDeviceDto } from '../../../../services/passcodes/passcodes.service';

export const MAX_RECENTS = 5;
const KEY = 'accefy.lockpicker.recents';

export function getRecentLockIds(): string[] {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) {
            return [];
        }
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
    } catch {
        return [];
    }
}

export function pushRecentLock(id: string): void {
    const next = [id, ...getRecentLockIds().filter((x) => x !== id)].slice(0, MAX_RECENTS);
    try {
        window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        /* storage lleno / no disponible: best-effort, se ignora */
    }
}

export function orderLocksByRecents(
    locks: PasscodesDeviceDto[],
    recentIds: string[],
): { recents: PasscodesDeviceDto[]; rest: PasscodesDeviceDto[] } {
    const byId = new Map(locks.map((l) => [l.id, l]));
    const recents = recentIds.map((id) => byId.get(id)).filter((l): l is PasscodesDeviceDto => !!l);
    const recentSet = new Set(recents.map((l) => l.id));
    const rest = locks.filter((l) => !recentSet.has(l.id));
    return { recents, rest };
}
